import React, { useState, useEffect } from 'react';
import { Truck, Clock } from 'lucide-react';
import { deliveryCountdown, countdownLabel } from '../../lib/deliveryHours';

const WHEN = ['Pirmdien', 'Otrdien', 'Trešdien', 'Ceturtdien', 'Piektdien', 'Sestdien', 'Svētdien'];

// Live "open / closed for delivery" banner with a countdown to the next window.
// Renders nothing when the delivery schedule is absent or unrestricted.
export default function DeliveryStatusBanner({ dh }) {
  const [, setTick] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setTick((t) => t + 1), 30000);
    return () => clearInterval(id);
  }, []);

  const cd = deliveryCountdown(dh);
  if (!cd) return null;

  if (cd.openNow) {
    return (
      <div className="rounded-xl border border-emerald-500/40 bg-emerald-500/10 px-4 py-2.5 flex items-center gap-2.5 text-sm flex-wrap"
        data-testid="delivery-status-banner" data-open="true">
        <span className="relative flex h-2.5 w-2.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-60" />
          <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-emerald-500" />
        </span>
        <Truck className="w-4 h-4 text-emerald-400" />
        <span className="font-semibold text-emerald-300">Atvērts piegādei</span>
        <span className="text-[var(--text-faint,rgba(255,255,255,0.55))]">· līdz {cd.at}{cd.minsUntil <= 90 ? ` (vēl ${countdownLabel(cd.minsUntil)})` : ''}</span>
      </div>
    );
  }

  const soon = cd.minsUntil != null && cd.minsUntil < 1440;
  const when = cd.at ? (soon ? `${countdownLabel(cd.minsUntil)} (${cd.at})` : `${WHEN[cd.day]} ${cd.at}`) : null;
  return (
    <div className="rounded-xl border border-amber-500/40 bg-amber-500/10 px-4 py-2.5 flex items-center gap-2.5 text-sm flex-wrap"
      data-testid="delivery-status-banner" data-open="false">
      <Clock className="w-4 h-4 text-amber-400" />
      <span className="font-semibold text-amber-300">Piegāde šobrīd slēgta</span>
      {when && <span className="text-[var(--text-faint,rgba(255,255,255,0.55))]">· atsāksies {when}</span>}
      <span className="text-[var(--text-faint,rgba(255,255,255,0.55))]">· pasūtīt var jau tagad</span>
    </div>
  );
}
